<template>
  <vue-final-modal
    v-model="show"
    :ssr="false"
    :lock-scroll="false"
    :name="modalName"
    hide-overlay
    class="fullscreen-modal"
    content-class="dialog-modal__content"
    :content-style="{
      height: '100%',
      width: '100%'
    }"
    :click-to-close="false"
    @closed="closed"
  >
    <div class="no-margin-bottom">
      <div class="full-screen-modal-top-band">
        <tr-svg-icon
          classes="cursor-pointer margin-right full-screen-modal-close-btn pull-right"
          color="white"
          :on-button-click="close"
          name="ic-close"
        />
      </div>
    </div>
    <div
      class="v-full-screen-modal-container"
      :style="{
        height: `calc(100% - ${topbarHeight})`
      }"
    >
      <div class="container bottom-offset4">
        <slot />
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
import { VueFinalModal } from 'vue-final-modal'
import TrSvgIcon from './TrSvgIcon.vue';

export default {
  name: 'TrFullscreenModal',
  components: {
    TrSvgIcon,
    VueFinalModal
  },
  props: {
    name: {
      required: true,
      type: String
    },
    uniqueName: {
      required: false,
      type: Boolean,
      default: false
    },
    onClose: {
      required: false,
      type: Function
    }
  },
  data() {
    return {
      show: false,
      topbarHeight: '45px',
      dialogStack: this.$injectDialogStack?.()
    }
  },
  computed: {
    modalName() {
      if (this.uniqueName) {
        return this.name + this._generateRandomId();
      }
      return this.name;
    },
  },
  methods: {
    open() {
      this.show = true;

      if (this.dialogStack) {
        this.dialogStack.open(this)
      }
    },
    close() {
      this.show = false;
    },
    closed() {
      if (this.onClose) {
        this.onClose();
      }

      if (this.dialogStack) {
        this.dialogStack.close(this)
      }
    },
    _generateRandomId() {
      return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
    }
  }
};
</script>

<style scoped>
.fullscreen-modal {
  margin-top: 50px;
}

:deep(.dialog-modal__content) {
  background-color: #fff;
}
</style>
